import { createMuiTheme } from '@material-ui/core/styles';
import { CHANGE_THEME, LOADING_THEME } from '../actions/types/appTypes';

import themeConfig from '../../theme-config';
import { SHOW_LOADING, HIDE_LOADING } from '../actions/types/loadingTypes';

const INITIAL_STATE = {
  themeConfig: createMuiTheme(themeConfig),
  loadingTheme: true,
  loading: false,
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {

    case LOADING_THEME: return { ...state, loadingTheme: action.result };
    case CHANGE_THEME: return { ...state, themeConfig: action.result };
    case SHOW_LOADING: return { ...state, loading: true };
    case HIDE_LOADING: return { ...state, loading: false };
    default: return state;

  }

};



// WEBPACK FOOTER //
// ./src/redux/reducers/appReducer.js